import axios from "axios";

// assetNodeId lives in the path for the single-delete case, so the base is a function.
const userDepartmentsUrl = (userId) => `/api/users/${userId}/departments`;

const throwResponseData = (error) => {
  throw error.response?.data ?? error;
};

export const fetchUserDepartments = async (userId, companyKey) => {
  try {
    const response = await axios.get(userDepartmentsUrl(userId), {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

/*
 * Replace-set, not a delta: assetNodeIds is the user's complete membership after the
 * call. Mirrors how roles are saved on the user itself, so the two multi-selects in the
 * user dialog behave identically.
 */
export const replaceUserDepartments = async (userId, companyKey, assetNodeIds) => {
  try {
    const response = await axios.put(userDepartmentsUrl(userId), {
      companyKey: Number(companyKey),
      assetNodeIds: (assetNodeIds ?? []).map(Number),
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const removeUserDepartment = async (userId, companyKey, assetNodeId) => {
  try {
    const response = await axios.delete(`${userDepartmentsUrl(userId)}/${assetNodeId}`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};
